'use strict';
/*eslint-disable react/no-danger*/
import PropTypes from 'prop-types';

import styles from "./Interview.module.css";

const renderQuestion = (Question) => {
  if (typeof Question === "string") {
    return <h3>{Question}</h3>
  } else {
    return <h3 dangerouslySetInnerHTML={{__html: Question.props.value}} />
  }

}

const Interview = (props) => {
  const {
    Question = "",
    Answer = {
      props: {
        value: ""
      }
    }
  } = props;
  return (
    <div className={[styles["interview"], "interview"].join(" ")}>
      {renderQuestion(Question)}
      <div dangerouslySetInnerHTML={{ __html: Answer.props.value}} />
    </div>
  );
}

Interview.propTypes = {
  Question: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  Answer: PropTypes.object
};

export default Interview;
